// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Publications_publications__pnlcn {
  display: flex;
  flex-direction: column;
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 {
  margin-bottom: 25px;
  background: white;
  border-radius: 5px;
  padding: 15px 20px;
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_coauthors__dAR1u {
  margin-bottom: 3px;
  color: var(--dark-grey);
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_coauthors__dAR1u span {
  margin-right: 10px !important;
  font-style: italic;
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_title__mnIHb {
  margin-bottom: 3px;
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_title__mnIHb .Publications_paper-title__63Mbb {
  font-weight: bold;
  cursor: pointer;
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_title__mnIHb .Publications_paper-title__63Mbb:hover {
  text-decoration: underline;
  color: var(--blue);
}
.Publications_publications__pnlcn .Publications_publication__Mj8X9 .Publications_title__mnIHb .Publications_venue__8ywL2 {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/Admin/Pages/PersonalProfile/Components/Publications/Publications.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF;AAAE;EACE,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;AAEJ;AADI;EACE,kBAAA;EACA,uBAAA;AAGN;AAFM;EACE,6BAAA;EACA,kBAAA;AAIR;AADI;EACE,kBAAA;AAGN;AAFM;EACE,iBAAA;EACA,eAAA;AAIR;AAFM;EACE,0BAAA;EACA,kBAAA;AAIR;AAFM;EACE,kBAAA;AAIR","sourcesContent":[".publications {\n  display: flex;\n  flex-direction: column;\n  .publication {\n    margin-bottom: 25px;\n    background: white;\n    border-radius: 5px;\n    padding: 15px 20px;\n    .coauthors {\n      margin-bottom: 3px;\n      color: var(--dark-grey);\n      span {\n        margin-right: 10px !important;\n        font-style: italic;\n      }\n    }\n    .title {\n      margin-bottom: 3px;\n      .paper-title {\n        font-weight: bold;\n        cursor: pointer;\n      }\n      .paper-title:hover {\n        text-decoration: underline;\n        color: var(--blue);\n      }\n      .venue {\n        font-style: italic;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"publications": `Publications_publications__pnlcn`,
	"publication": `Publications_publication__Mj8X9`,
	"coauthors": `Publications_coauthors__dAR1u`,
	"title": `Publications_title__mnIHb`,
	"paper-title": `Publications_paper-title__63Mbb`,
	"venue": `Publications_venue__8ywL2`
};
export default ___CSS_LOADER_EXPORT___;
